// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__fBoMI","containerItemsCenter":"Skeleton_containerItemsCenter__1x8nQ"};